module.exports = __webpack_public_path__ + "z/simple-desktop.d285eb0c.png";